import { i18n } from '@/i18n';
import apiMsgKeysFlatZhCn from '@/i18n/api-msg-keys-flat.zh-cn.json';

const zhMsgKeyMap = apiMsgKeysFlatZhCn as Record<string, string>;

function currentLocale(): string {
  return typeof (i18n.global.locale as any)?.value === 'string'
    ? (i18n.global.locale as any).value
    : String(i18n.global.locale);
}

/**
 * 接口错误提示：msgKey 命中当前 locale 的 vue-i18n 则用之；否则用后端 msg；
 * 再无则用语义目录中文兜底；最后 fallbackI18nKey（默认「请求失败」）。
 */
export function resolveApiErrorToastMessage(
  msgKey: string | null | undefined,
  msg: string | null | undefined,
  fallbackI18nKey: string = 'qqsb',
): string {
  const rawMsg = msg != null && String(msg).trim() ? String(msg).trim() : '';
  const key =
    msgKey != null && String(msgKey).trim() ? String(msgKey).trim() : '';
  const locale = currentLocale();
  const g = i18n.global as any;

  if (key && g.te(key, locale)) {
    return String(g.t(key, {}, { locale }));
  }
  if (rawMsg) {
    return rawMsg;
  }
  if (key) {
    const zh = zhMsgKeyMap[key];
    if (zh) {
      return zh;
    }
  }
  return String(g.t(fallbackI18nKey, {}, { locale }));
}
